import {
    EDIT_ADD_MODULE_MASTER_SUCCESS,
    EDIT_ADD_MODULE_MASTER_FAILED,
    LOADING_RESET_EDIT_ADD_MODULE_MASTER,
    NETWORK_ERROR_RESET_EDIT_ADD_MODULE_MASTER
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminAddEditModuleMaster =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_RESET_EDIT_ADD_MODULE_MASTER });
        await adminServices
            .post("addOrUpdateModulemaster", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: EDIT_ADD_MODULE_MASTER_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: EDIT_ADD_MODULE_MASTER_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_RESET_EDIT_ADD_MODULE_MASTER,
                    payload: err
                });
            });
    };

export { adminAddEditModuleMaster };
